import { FC } from 'react'

import { QuickBuy, useSupportsHover } from '@syconium/little-miss-figgy'

import { trackEvent } from '../../../../../../../../../lib/analytics'

import { Body } from './styles'
import { useQuickBuyOverlayController } from './useQuickBuyOverlayController'

import type { IProps } from './IProps'

export const QuickBuyOverlay: FC<IProps> = ({
  embroideryConfig,
  activeProductFinalSale,
  analyticsContext,
  category,
  coloredVariants,
  ctaOnly = false,
  fitKeys,
  isCurrentColorCompletelySoldOut,
  isFavorites,
  onAddToCart,
  openQuickBuyModal,
  preferences,
  selectedFitKey,
  setSelectedFitKey,
  sizes,
  useLargeWidthSizeSelectorItems,
  rawCategory,
}) => {
  const supportsHover = useSupportsHover()

  const { height, steps } = useQuickBuyOverlayController({
    activeProductFinalSale,
    category,
    coloredVariants,
    ctaOnly,
    fitKeys,
    embroideryConfig,
    onAddToCart,
    openQuickBuyModal,
    preferences,
    selectedFitKey,
    setSelectedFitKey,
    sizes,
    supportsHover,
    rawCategory,
  })

  if (isCurrentColorCompletelySoldOut) return null
  return (
    <Body
      $isFavorites={isFavorites}
      $ctaOnly={ctaOnly}
      $heightPixels={height}
      $hideOnDesktop={isCurrentColorCompletelySoldOut}
      $useLargeWidthSizeSelectorItems={useLargeWidthSizeSelectorItems}
    >
      <button
        aria-label='Quick Buy'
        onClick={steps.initial.onSelect}
        ref={steps.initial.ref}
        {...trackEvent({
          action: 'click',
          category: `${analyticsContext.category} quick buy`,
          label: 'quick-buy',
        })}
      >
        <QuickBuy />
      </button>
    </Body>
  )
}
